var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-flex align-self-end justify-content-end"},[_c('div',{staticClass:"btnFS btn",on:{"click":function($event){return _vm.switchFS()}}},[_c('span',{staticClass:"icon-fullscreen"})])])}
var staticRenderFns = []

export { render, staticRenderFns }